import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import React, {Component, useEffect} from 'react';
import {useNavigate} from "react-router-dom";

function Header() {
    const navigate = useNavigate();

    return (
        // eslint-disable-next-line react/react-in-jsx-scope
        <Navbar bg="light" expand="lg">
            <Container fluid>
                <Navbar.Brand href="/">Easy Street</Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                    <Nav
                        className="me-auto my-2 my-lg-0"
                        style={{ maxHeight: '100px' }}
                        navbarScroll
                    >
                        <NavDropdown title="Apps" id="navbarScrollingDropdown">
                            <NavDropdown.Item href="/games">All</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="/genres">Genres</NavDropdown.Item>
                            <NavDropdown.Item href="/categories">Categories</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link href="/categories">Categories</Nav.Link>
                        <Nav.Link href="/publishers">Publishers</Nav.Link>
                        <Nav.Link href="/account">Account</Nav.Link>
                    </Nav>
                    <Form className="d-flex" onSubmit={(e) => {
                        e.preventDefault();

                        if(e.target.search.value.length > 0) {
                            navigate('/games/search/' + e.target.search.value)
                        }
                    }}>
                        <Form.Control
                            type="search"
                            placeholder="Search"
                            className="me-2"
                            aria-label="Search"
                            name="search"
                        />
                        <Button type="submit" variant="outline-success">Search</Button>
                    </Form>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;
